import { render } from "./ButtonGeneral.vue?vue&type=template&id=42d645b4"
import script from "./ButtonGeneral.vue?vue&type=script&lang=js"
export * from "./ButtonGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
